
export const marketplaceData = {
  categories: [
    'Recruiting & Onboarding',
    'Compensation',
    'Benefits',
    'Benefits Administration',
    'Time & Labor Management',
    'Learning Management',
    'Performance',
    'Financial Wellness',
    'POS Integration',
    'Data Connectors',
    'Productivity & Collaboration',
    'Reward & Recognition',
    'Travel & Expense',
    'Compliance & Consulting',
    'HRIS',
    'Earned Wage Access',
    'Global EOR/AOR',
    'API Access',
  ],

  products: {
    'Recruiting & Onboarding': [
      {
        id: 1,
        name: 'VidCruiter',
        company: 'by VidCruiter Inc.',
        category: 'Recruiting & Onboarding',
        description: "VidCruiter's suite of automated recruiting tools puts you firmly in control of every stage of the hiring process.",
        rating: 4.8,
        reviews: 237,
        bestseller: true,
        logo: 'Vid',
        logoColor: '#28a745',
      },
      {
        id: 2,
        name: 'Evolve Talent Acquisition Suite by Jobvite',
        company: 'by Jobvite',
        category: 'Recruiting & Onboarding',
        description: 'The Evolve Talent Acquisition Suite by Jobvite delivers technology that is broad enough to meet your recruiting needs.',
        rating: 4.1,
        reviews: 599,
        bestseller: true,
        logo: 'JOBVITE',
        logoColor: '#007bff',
      },
      {
        id: 3,
        name: 'iCIMS Talent Cloud',
        company: 'by ICIMS',
        category: 'Recruiting & Onboarding',
        description: "At iCIMS, we empower leaders to build a winning workforce using the world's leading talent acquisition platform.",
        rating: 4.1,
        reviews: 715,
        bestseller: true,
        logo: 'icims',
        logoColor: '#6c757d',
      },
    ],
    'Compensation': [
      {
        id: 4,
        name: 'PayScale MarketPay',
        company: 'by PayScale',
        category: 'Compensation',
        description: 'Real-time compensation data and analytics to make informed pay decisions.',
        rating: 4.3,
        reviews: 156,
        bestseller: false,
        logo: 'PayScale',
        logoColor: '#ff6b6b',
      },
    ],
    'Benefits': [
      {
        id: 5,
        name: 'Benefit Focus',
        company: 'by Benefitfocus',
        category: 'Benefits',
        description: 'Comprehensive benefits administration and employee engagement platform.',
        rating: 4.0,
        reviews: 89,
        bestseller: false,
        logo: 'BF',
        logoColor: '#4ecdc4',
      },
    ],
  },

  categoryDescriptions: {
    'Recruiting & Onboarding': 'Find and hire the right people.',
    'Compensation': 'Manage and optimize compensation strategies.',
    'Benefits': 'Streamline benefits administration and enrollment.',
    'Benefits Administration': 'Comprehensive benefits management solutions.',
    'Time & Labor Management': 'Track time and manage workforce scheduling.',
    'Learning Management': 'Employee training and development platforms.',
    'Performance': 'Performance management and review systems.',
    'Financial Wellness': 'Financial health and wellness programs.',
    'POS Integration': 'Point of sale system integrations.',
    'Data Connectors': 'Data integration and connectivity solutions.',
    'Productivity & Collaboration': 'Tools to enhance workplace productivity.',
    'Reward & Recognition': 'Employee recognition and reward programs.',
    'Travel & Expense': 'Travel booking and expense management.',
    'Compliance & Consulting': 'Compliance management and consulting services.',
    'HRIS': 'Human resource information systems.',
    'Earned Wage Access': 'Early wage access solutions.',
    'Global EOR/AOR': 'Global employer and agent of record services.',
    'API Access': 'API integration and development tools.',
  },
};

// Countries for the header country selector
export const countries = [
  { name: 'United States', value: 'en-US' },
  { name: 'Canada (English)', value: 'en-CA' },
  { name: 'Canada (French)', value: 'fr-CA' },
  { name: 'International (English)', value: 'en-US(INT)' },
  { name: 'International (French)', value: 'fr-FR' },
  { name: 'International (Dutch)', value: 'nl-NL' },
  { name: 'International (Portuguese)', value: 'pt-BR' },
];

export const CART_ITEMS = [
  {
    id: 1,
    title: 'Product® API Central for ADP Workforce Now® and ADP Workforce Now® Next Generation',
    author: 'ADP',
    edition: 'ADP API Central',
    image: null,
  }
];
